import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { TextField } from '@consta/uikit/TextField';
import { Text } from '@consta/uikit/Text';
import classNames from 'classnames';
import t from 'i18n';

import './fieldPassword.scss';

@observer
export class FieldPassword extends Component {
	removeReadOnlyProp = (e) => {
		e.target.removeAttribute('readonly');
	};

	render() {
		const { className, label, error, caption, isRequired, onChange, value, onKeyUp, ...restProps } = this.props;
		const addProps = {};
		if (onKeyUp) {
			addProps.onKeyUp = onKeyUp;
		}

		const hasCaption = caption || error;
		const fieldCaption = hasCaption ? (
			<>
				{caption}
				{error && <Text view='alert'>{error}</Text>}
			</>
		) : null;

		return (
			<div className={classNames('input-password field', className)}>
				<TextField
					{...restProps}
					onChange={onChange}
					value={value}
					label={label}
					required={isRequired}
					type='password'
					name='password'
					placeholder={t('password.input')}
					caption={fieldCaption}
					onFocus={this.removeReadOnlyProp}
					{...addProps}
				/>
			</div>
		);
	}
}
